// src/modules/auth/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import LoadingSpinner from '../../components/shared/LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;  // Use the loading spinner while loading
  }

  if (!isAuthenticated) {
    localStorage.setItem( 'redirectUrl', location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  // Field employees are locked to their own portal — every other page redirects
  // them to /my-time (they're also API-blocked server-side outside time-tracking).
  if (user?.role === 'employee' && !location.pathname.startsWith('/my-time')) {
    return <Navigate to="/my-time" replace />;
  }

  return children;
};

export default ProtectedRoute;